import { useTranslation } from 'react-i18next'
import { RefreshCw } from 'lucide-react'
import type { SyncRun } from '@/lib/api/sources.ts'
import { SyncProgress } from './SyncProgress.tsx'

export function SyncBar({ run }: { run: SyncRun }) {
  const { t } = useTranslation()

  return (
    <aside
      aria-live="polite"
      className="bg-gradient-panel-elevated sync-morph fixed bottom-4 right-4 z-40 w-64 rounded-xl border border-border p-3 shadow-[0_24px_48px_-24px_rgba(0,0,0,0.8)]"
    >
      <div className="flex items-center gap-2">
        <RefreshCw className="h-3.5 w-3.5 shrink-0 animate-spin text-primary" aria-hidden="true" />
        <p className="truncate text-xs font-semibold text-foreground">
          {t('pages.pipelines.sync.bar', { defaultValue: 'Syncing' })}
        </p>
      </div>
      <SyncProgress run={run} className="mt-2" />
      <p className="mt-1 text-[11px] text-muted">
        {t('pages.pipelines.sync.barHint', { defaultValue: 'These numbers are not final yet.' })}
      </p>
    </aside>
  )
}
